import ApiService from '@/utils/ApiService'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: []
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    }
  },
  actions: {
    async getItems ({ commit }, page = 'e_x_c_m_messages', params) {
      commit('toggleLoading')
      page = addParamsToQuery(page, {
        approvalStatus: 0
      })
      const response = await new ApiService(page, params).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('toggleLoading')
    }
  }
}
